import { ANNOTATION_CLICKED, OVERLAY_CLICKED, TOGGLE_ANNOTATIONS_VISIBILITY_CLICK } from '../../stateManager/collaborations/types';
import * as CurrentsActions from '../../actions/current';
import { deleteComment, updateComment } from '../../actions/comments';

export function annotationClicked(payload) {
    return (dispatch) => {
        if (payload.commentId) {
            dispatch(CurrentsActions.setCurrentCommentId(payload.commentId));
        }

        dispatch({
            type: ANNOTATION_CLICKED,
            payload
        });
    };
}

export function overlayClicked(payload) {
    return (dispatch) => {
        dispatch(CurrentsActions.setCurrentCommentId(undefined));
        dispatch({
            type: OVERLAY_CLICKED,
            payload
        });
    };
}

export function toggleAnnotationsVisible() {
    return { type: TOGGLE_ANNOTATIONS_VISIBILITY_CLICK };
}

export function selectCommentIdByAnnotationId(annotationId) {
    return (dispatch, getState) => {
        const state = getState();
        const commentToBeSelected = Object.values(state.comments).find((comment) => comment.annotations && comment.annotations.length && comment.annotations[0].id === annotationId);
        if (commentToBeSelected) {
            dispatch(CurrentsActions.setCurrentCommentId(commentToBeSelected.id));
        }
    };
}

export function deleteCommentByAnnotationId(annotationId) {
    return (dispatch, getState) => {
        const state = getState();
        const commentToBeDeleted = Object.values(state.comments).find((comment) => comment.annotations && comment.annotations.length && comment.annotations[0].id === annotationId);
        if (commentToBeDeleted) {
            dispatch(deleteComment(commentToBeDeleted.id));
        }
    };
}

export function updateCommentByAnnotation(annotation) {
    return (dispatch, getState) => {
        const state = getState();
        const commentToBeUpdated = Object.values(state.comments).find((comment) => comment.annotations && comment.annotations.length && comment.annotations[0].id === annotation.id);
        if (commentToBeUpdated) {
            commentToBeUpdated.annotations[0].target.selector.strokeColor = annotation.target.selector.strokeColor;
            dispatch(updateComment(commentToBeUpdated));
        }
    };
}
